/** Fixed-size FIFO used for breadcrumbs and recent requests. */
export class RingBuffer<T> {
  private items: T[] = [];

  constructor(private readonly capacity: number) {}

  push(item: T): void {
    this.items.push(item);
    if (this.items.length > this.capacity) this.items.splice(0, this.items.length - this.capacity);
  }

  toArray(): T[] {
    return this.items.slice();
  }

  last(n: number): T[] {
    return this.items.slice(-n);
  }

  clear(): void {
    this.items = [];
  }

  get length(): number {
    return this.items.length;
  }
}
